<div class="flex flex-col h-min-[450px]">

    <!-- ── VISTA BUSCADOR ── -->
    <div class="flex flex-col flex-1 gap-4">
        <!-- Search Bar -->
        <div class="relative group">

            <div
                class="absolute left-3.5 top-1/2 -translate-y-1/2 text-primary z-10 pointer-events-none flex items-center">
                <iconify-icon icon="solar:magnifer-bold-duotone" width="18" height="18"></iconify-icon>
            </div>

            <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange(searchTerm)" [placeholder]="placeholder"
                class="w-full bg-surface/50 dark:bg-slate-800/60 border border-foreground/10 dark:border-white/5 rounded-xl py-2.5 pl-10 pr-12 text-sm font-medium outline-none transition-all focus:border-primary focus:ring-4 focus:ring-primary/5 text-foreground shadow-sm"
                autofocus />

            <!-- Right Actions (Loading & Clear) -->
            <div class="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2 z-20">
                <div *ngIf="isLoading()"
                    class="w-4 h-4 border-2 border-primary/20 border-t-primary rounded-full animate-spin"></div>

                <button type="button" *ngIf="searchTerm && !isLoading()" (click)="clearSearch()"
                    class="text-text-muted hover:text-red-500 transition-colors flex items-center active:scale-95">
                    <iconify-icon icon="solar:trash-bin-trash-bold-duotone" width="18" height="18"></iconify-icon>
                </button>
            </div>
        </div>

        <!-- Results List -->
        <div class="flex-1 overflow-y-auto custom-scrollbar pr-1 -mr-1" (scroll)="onScroll($event)">

            <div *ngIf="results().length > 0; else emptyState" class="flex flex-col gap-1.5">
                <div *ngFor="let item of results()" (click)="select(item)"
                    class="group flex items-center gap-3 p-2.5 rounded-xl bg-surface/30 dark:bg-slate-800/30 border border-transparent hover:border-primary/30 hover:bg-primary/5 cursor-pointer transition-all active:scale-[0.98]">

                    <!-- Avatar/Icon -->
                    <div
                        class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0 group-hover:scale-105 transition-transform">
                        <iconify-icon [icon]="entityIcon" width="20" height="20"></iconify-icon>
                    </div>

                    <!-- Info -->
                    <div class="flex-1 min-w-0">
                        <h4
                            class="text-sm font-bold text-foreground truncate group-hover:text-primary transition-colors">
                            {{ displayFn(item) }}
                        </h4>
                        <div class="flex items-center gap-2 mt-0.5">
                            <!-- Patient info -->
                            <p *ngIf="item.identification"
                                class="text-[9px] text-text-muted font-bold tracking-wider uppercase opacity-60">
                                ID: {{ item.identification }}
                            </p>
                            <p *ngIf="item.phone" class="text-[9px] text-primary/70 font-bold">
                                {{ item.phone }}
                            </p>
                            <!-- Doctor info -->
                            <p *ngIf="item.user?.email"
                                class="text-[9px] text-text-muted font-bold tracking-wider uppercase opacity-60">
                                {{ item.user.email }}
                            </p>
                            <p *ngIf="item.specialty" class="text-[9px] text-primary/70 font-bold">
                                {{ item.specialty }}
                            </p>
                        </div>
                    </div>

                    <!-- Selection Icon -->
                    <div
                        class="w-7 h-7 rounded-lg bg-foreground/[0.03] flex items-center justify-center text-text-muted group-hover:bg-primary group-hover:text-white transition-all opacity-0 group-hover:opacity-100">
                        <iconify-icon icon="solar:check-read-bold" width="16" height="16"></iconify-icon>
                    </div>
                </div>
            </div>

            <ng-template #emptyState>
                <div *ngIf="!isLoading()" class="flex flex-col items-center justify-center py-8 text-center">
                    <div class="w-16 h-16 rounded-full bg-surface-muted/10 flex items-center justify-center mb-3">
                        <iconify-icon icon="solar:magnifer-zoom-out-bold-duotone"
                            class="text-3xl text-text-muted opacity-20"></iconify-icon>
                    </div>
                    <p class="text-xs text-text-muted font-bold uppercase tracking-widest">
                        {{ searchTerm ? 'Sin resultados para "' + searchTerm + '"' : 'Comienza a escribir...' }}
                    </p>
                </div>
            </ng-template>
        </div>
    </div>


</div>


<!-- ── MODAL CREACIÓN (Sólo médicos) ── -->